import { BLACK, LILAC_200, fitContentWidth, tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getDescriptionVariantColor = () => {
  return {
    backgroundColor: LILAC_200,
    borderColor: 'white',
    color: BLACK,
    text: BLACK
  };
};
export var getDescriptionWidgetStyles = () => {
  var spacingToken = tokens.spacing;
  var colorTypes = getDescriptionVariantColor();
  return StyleSheet.create({
    descriptionContainer: Object.assign({
      flexDirection: 'row',
      backgroundColor: colorTypes.backgroundColor,
      alignItems: 'center',
      borderRadius: tokens.borderRadius.BORDER_RADIUS_24,
      borderWidth: spacingToken.SPACING_1,
      borderColor: colorTypes.borderColor,
      padding: spacingToken.SPACING_10
    }, fitContentWidth())
  });
};